import { FeePaymentType } from '@nemuru-eng/js-api-client';

export const getTidBySetupFeeType = (setupFeeType: FeePaymentType, amount?: number) => {
  if (!amount) return 'TOTAL_COST';

  switch (setupFeeType) {
    case FeePaymentType.TYPE_UPFRONT:
      return 'TOTAL_COST_WITH_UPFRONT_PERCENTAGE';
    case FeePaymentType.TYPE_FINANCED:
      return 'TOTAL_COST_WITH_FINANCED_PERCENTAGE';
    case FeePaymentType.TYPE_FIXED_AMOUNT:
      return 'TOTAL_COST_WITH_FIXED_AMOUNT_VALUE';
    default:
      return 'TOTAL_COST_WITH_UPFRONT_PERCENTAGE';
  }
};
